export default [
  {
    value: 1,
    label: '上架'
  },
  {
    value: 0,
    label: '下架'
  }
]
